import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

declare var $:any;

declare var gtag;

@Component({
  selector: 'seguros-empresas-header-component',
  templateUrl: './seguros-empresas-header.component.html',
  styleUrls: ['./seguros-empresas-header.component.scss']
})
export class SegurosEmpresasHeaderComponent implements OnInit {


  
  @Input('HeaderHtml')HeaderHtml;
  @Input('menuHeaderHtml') menuHeaderHtml;
  @Input('BotonesDeSlides')BotonesDeSlides;
  @Input('menuFooterHtml')menuFooterHtml;

  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() buscar: EventEmitter<any> = new EventEmitter();
  

  constructor() { 
    
  }

  ngOnInit() {
    $(".layer").click(function (event) {
      $("#lg_slide").fadeIn(500, function () {
      });
    });
  }

  redireccionarAPaginaExistente(uuid){
    
    this.uuid.emit(uuid);

     gtag('config', 'UA-118311338-3',{
        'page' : '/seguros-empresas/'+uuid, 
        'page-path':'/seguros-empresas/'+uuid,
        'page_title' : '/seguros-empresas/'+uuid,
        'page_location' : '/seguros-empresas/'+uuid
        });
        
    $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    $("#lg_slide").removeClass("active");
  }

  search(){
   this.buscar.emit(true);
   $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    // $("#lg_slide").removeClass("active");
    // $(".c-body").removeClass("overflow-hidden");
   
  }

}
